(function () {
  'use strict';

  function initDesktopNavigation() {
    var navigations = document.querySelectorAll(
      '.bedz-global-nav'
    );

    if (!navigations.length) {
      return;
    }

    Array.prototype.forEach.call(navigations, function (navigation) {
      var disclosures = Array.prototype.slice.call(
        navigation.querySelectorAll('.bedz-global-nav__disclosure')
      );

      function closeAll(exceptDisclosure) {
        disclosures.forEach(function (disclosure) {
          if (disclosure !== exceptDisclosure) {
            disclosure.removeAttribute('open');
          }
        });
      }

      function openDisclosure(disclosure) {
        closeAll(disclosure);
        disclosure.setAttribute('open', '');
      }

      disclosures.forEach(function (disclosure) {
        disclosure.addEventListener('toggle', function () {
          if (disclosure.open) {
            closeAll(disclosure);
          }
        });

        var trigger = disclosure.querySelector('.bedz-global-nav__trigger');

     if (trigger) {
     trigger.addEventListener('click', function (event) {
     event.preventDefault();

    var openedByClick =
      disclosure.getAttribute('data-bedz-click-open') === 'true';

    if (openedByClick) {
      disclosure.removeAttribute('data-bedz-click-open');
      disclosure.removeAttribute('open');
    } else {
      closeAll();
      disclosure.setAttribute('data-bedz-click-open', 'true');
      disclosure.setAttribute('open', '');
    }
  });
}

        /* Desktop mouse users: reveal the dropdown without a click */
disclosure.addEventListener('mouseenter', function () {
  openDisclosure(disclosure);
});

disclosure.addEventListener('mouseleave', function () {
  disclosure.removeAttribute('data-bedz-click-open');

  if (!disclosure.contains(document.activeElement)) {
    disclosure.removeAttribute('open');
  }
});
        /* Keyboard users: focusing the summary opens the disclosure and */
        disclosure.addEventListener('focusin', function (event) {
  if (event.target !== trigger) {
    openDisclosure(disclosure);
  }
});

        disclosure.addEventListener('focusout', function () {
          window.setTimeout(function () {
          if (
  !disclosure.contains(document.activeElement) &&
  !disclosure.matches(':hover')
) {
  disclosure.removeAttribute('open');
}
          }, 0);
        });
      });

      document.addEventListener('click', function (event) {
        if (!navigation.contains(event.target)) {
          closeAll();
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') {
          return;
        }

        var openDisclosure = navigation.querySelector(
          '.bedz-global-nav__disclosure[open]'
        );

        if (!openDisclosure) {
          return;
        }

        var trigger = openDisclosure.querySelector(
          '.bedz-global-nav__trigger'
        );

        openDisclosure.removeAttribute('open');

        if (trigger) {
          trigger.focus();
        }
      });
    });
  }

  function initCompactNavigation() {
    var navigation = document.querySelector(
      '[data-bedz-compact-nav]'
    );

    if (!navigation) {
      return;
    }

    var shopView = navigation.querySelector(
      '[data-bedz-compact-view="shop"]'
    );

    var helpView = navigation.querySelector(
      '[data-bedz-compact-view="help"]'
    );

    var helpTrigger = navigation.querySelector(
      '[data-bedz-compact-open-help]'
    );

    var backButton = navigation.querySelector(
      '[data-bedz-compact-back]'
    );

    var groupButtons = Array.prototype.slice.call(
      navigation.querySelectorAll(
        '[data-bedz-help-target]'
      )
    );

    var groupPanels = Array.prototype.slice.call(
      navigation.querySelectorAll(
        '[data-bedz-help-panel]'
      )
    );

    function closeHelpGroups() {
      groupButtons.forEach(function (button) {
        button.setAttribute(
          'aria-expanded',
          'false'
        );
      });

      groupPanels.forEach(function (panel) {
        panel.hidden = true;
      });
    }

    function showShopView(restoreFocus) {
      closeHelpGroups();

      if (helpView) {
        helpView.hidden = true;
      }

      if (shopView) {
        shopView.hidden = false;
      }

      if (helpTrigger) {
        helpTrigger.setAttribute(
          'aria-expanded',
          'false'
        );
      }

      if (
        restoreFocus &&
        helpTrigger
      ) {
        helpTrigger.focus();
      }
    }

    function showHelpView() {
      closeHelpGroups();

      if (shopView) {
        shopView.hidden = true;
      }

      if (helpView) {
        helpView.hidden = false;
      }

      if (helpTrigger) {
        helpTrigger.setAttribute(
          'aria-expanded',
          'true'
        );
      }

      if (backButton) {
        backButton.focus();
      }
    }

    if (helpTrigger) {
      helpTrigger.addEventListener(
        'click',
        showHelpView
      );
    }

    if (backButton) {
      backButton.addEventListener(
        'click',
        function () {
          showShopView(true);
        }
      );
    }

    groupButtons.forEach(function (button) {
      button.addEventListener(
        'click',
        function () {
          var target =
            button.getAttribute(
              'data-bedz-help-target'
            );

          var panel =
            navigation.querySelector(
              '[data-bedz-help-panel="' +
              target +
              '"]'
            );

          var wasOpen =
            button.getAttribute(
              'aria-expanded'
            ) === 'true';

          closeHelpGroups();

          if (
            !wasOpen &&
            panel
          ) {
            button.setAttribute(
              'aria-expanded',
              'true'
            );

            panel.hidden = false;
          }
        }
      );
    });

    navigation.addEventListener(
      'keydown',
      function (event) {
        if (event.key !== 'Escape') {
          return;
        }

        var openGroup =
          navigation.querySelector(
            '[data-bedz-help-target][aria-expanded="true"]'
          );

        if (openGroup) {
          closeHelpGroups();
          openGroup.focus();
          return;
        }

        if (
          helpView &&
          !helpView.hidden
        ) {
          showShopView(true);
        }
      }
    );

    var menuContainer =
      navigation.closest(
        '#menu-container'
      );

    if (
      menuContainer &&
      window.MutationObserver
    ) {
      var observer =
        new MutationObserver(
          function () {
            if (
              menuContainer.classList.contains(
                'hide'
              )
            ) {
              showShopView(false);
            }
          }
        );

      observer.observe(
        menuContainer,
        {
          attributes: true,
          attributeFilter: ['class']
        }
      );
    }
  }
  function initBedzGlobalNavigation() {
    initDesktopNavigation();
    initCompactNavigation();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initBedzGlobalNavigation
    );
  } else {
    initBedzGlobalNavigation();
  }
})();
